/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_Hint_PplInputs */

const en_us2_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push, pull and legs on separate days.`)
};

const pt_br2_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar, puxar e pernas em dias separados.`)
};

const es_419_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empuje, tirón y piernas en días separados.`)
};

const pt_pt2_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empurrar, puxar e pernas em dias separados.`)
};

const fr_fr2_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poussée, tirage et jambes sur des jours séparés.`)
};

const de_de2_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drücken, Ziehen und Beine an getrennten Tagen.`)
};

const it_it2_profile_editors_split_hint_ppl = /** @type {(inputs: Profile_Editors_Split_Hint_PplInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spinta, tirata e gambe in giorni separati.`)
};

/**
* | output |
* | --- |
* | "Push, pull and legs on separate days." |
*
* @param {Profile_Editors_Split_Hint_PplInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_hint_ppl = /** @type {((inputs?: Profile_Editors_Split_Hint_PplInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Hint_PplInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_hint_ppl(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_hint_ppl(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_hint_ppl(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_hint_ppl(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_hint_ppl(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_hint_ppl(inputs)
	return en_us2_profile_editors_split_hint_ppl(inputs)
});
export { profile_editors_split_hint_ppl as "profile-editors.split_hint_ppl" }